"use client";

import { cn } from "@/lib/utils";

interface PageLoadingStateProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  label?: string;
  labelClassName?: string;
  showSpinner?: boolean;
  spinnerClassName?: string;
}

export default function PageLoadingState({
  className,
  size = "md",
  label,
  labelClassName,
  showSpinner = true,
  spinnerClassName,
}: PageLoadingStateProps) {
  const resolvedLabelClassName =
    labelClassName === undefined ? "text-slate-600" : labelClassName;
  const spinnerSizeClass =
    size === "sm" ? "h-4 w-4" : size === "lg" ? "h-12 w-12" : "h-8 w-8";

  return (
    <div className={cn("flex items-center justify-center", className)}>
      {showSpinner ? (
        <div className="text-center">
          <div className="flex items-center justify-center">
            <div
              className={cn(
                "animate-spin rounded-full border-4 border-gray-200 border-t-blue-600",
                spinnerSizeClass,
                spinnerClassName,
              )}
              role="status"
              aria-label="Loading"
            >
              <span className="sr-only">Loading...</span>
            </div>
          </div>
          {label && (
            <p className={cn("mt-2", resolvedLabelClassName)}>{label}</p>
          )}
        </div>
      ) : (
        label && <span className={cn(resolvedLabelClassName)}>{label}</span>
      )}
    </div>
  );
}
